import React, { useEffect, useState } from "react";
import { Container, Nav } from "react-bootstrap";
import Link from "next/link";
import Logo from "../../../images/Logo.svg";
import * as s from "./index.module.scss";
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from "./EmblaCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import {
  IoArrowForward,
  IoChevronForward,
  IoHeadset,
  IoMenu,
} from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import links from "./utils/data";
import { useRouter } from "next/router";
import Image from "next/image";

const Layout = ({ toggle, setToggle, expanded, setExpanded }) => {
  return (
    // <div className={s.navbar}>
    <div className={`${s.navbar}`}>
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="navbar-brand"
            onClick={() => {
              setExpanded(false);
            }}
          >
            <Link href={"/"}>
              <Image
                loading="eager"
                src={Logo.src}
                alt="image"
                className="h-100 w-100"
                width={200}
                height={200}
              />
            </Link>
          </div>
          <div className={s.nav_links_container}>
            <div className={`flex-row-reverse ${s.call_link}`}>
              <a href="tel: (212) 913-9141" className={secondaryFont}>
                <IoHeadset size="20px" /> <span>Call us on</span> (212) 913-9141
              </a>
            </div>
            <button
              aria-label="menu icon"
              className="navbar-toggler pt-0"
              onClick={() => {
                setExpanded(!expanded);
              }}
            >
              <IoMenu size="40px" />
            </button>
            <nav
              className={`${s.nav_links} ${
                expanded ? s.show_nav : ""
              } d-lg-block`}
            >
              <NavLinks
                links={links}
                setExpanded={setExpanded}
                toggle={toggle}
                setToggle={setToggle}
              />
            </nav>
          </div>
        </div>
      </Container>
    </div>
  );
};

const NavLinks = ({ links, setExpanded, toggle, setToggle }) => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [normalDropdown, setNormalDropdown] = useState(false);
  const { asPath } = useRouter();

  useEffect(() => {
    const updateWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth);

    return () => {
      window.removeEventListener("resize", updateWindowWidth);
    };
  }, []);

  return (
    <Nav
      className={`justify-content-end align-items-center flex-grow-1 pt-0 pt-lg-3 ${s.offcanvas_nav}`}
      as={"ul"}
    >
      {links?.map(({ title, link, subLinks, isNormalDropdown }, idx) => {
        const isDesktop = windowWidth > 1024;
        if (subLinks.length !== 0 && !isNormalDropdown) {
          return (
            <Nav.Link
              key={idx}
              className={`ps-0 pe-0 pe-lg-4 ${s.sub_links_wrapper}`}
              as={"li"}
              onMouseLeave={() => {
                if (isDesktop) setToggle(false);
              }}
              onMouseEnter={() => {
                if (isDesktop) setToggle(true);
              }}
            >
              <div className={`ps-lg-0 ${s.has_sub} ${toggle ? s.rotate : ""}`}>
                <Link
                  className={`${secondaryFont} ${
                    link === asPath ? "active" : ""
                  }`}
                  href={link}
                  onClick={(e) => {
                    if (!isDesktop) {
                      e.preventDefault();
                      setToggle(!toggle);
                    }
                  }}
                  style={{
                    borderBottom:
                      link === asPath && isDesktop
                        ? "2px solid #1570EF"
                        : "2px solid transparent",
                    // transition: 'border-color 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid #1570EF";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid transparent";
                    }
                  }}
                >
                  {title}
                </Link>
                <IoChevronForward
                  size="22px"
                  onClick={() => {
                    setToggle(!toggle);
                  }}
                />
              </div>
              <div
                className={`${s.sub_links} ${s.mobile} ${
                  toggle ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              >
                {subLinks.map(({ title, link }, index) => {
                  return (
                    <div className="border-0 pt-3 pb-3" key={index}>
                      <Link
                        href={link}
                        onClick={() => {
                          setExpanded(false);
                        }}
                      >
                        {title}
                      </Link>
                    </div>
                  );
                })}
                <div className={`border-0 pt-3 pb-3 ${s.last_sub_list}`}>
                  <Link
                    // className={`ps-0 d-lg-none btn b-0 d-flex gap-2 justify-content-start ${s.see_all_mobile_link}`}
                    className={`ps-0 d-lg-none b-0 d-flex gap-2 justify-content-start 
                    ${isDesktop ? "btn" : ""} ${s.see_all_mobile_link}`}
                    href="/what-we-buy"
                    onClick={() => {
                      setExpanded(false);
                    }}
                  >
                    <span className={`${s.span_txt}`}>Things We Buy</span>{" "}
                    <IoArrowForward size="18px" />
                  </Link>
                </div>
              </div>
              <div
                className={`${s.sub_links} ${s.desktop} ${
                  toggle ? s.show_sub_links : ""
                } pt-0 pb-0`}
              >
                <DesktopSubMenu
                  subLinks={subLinks}
                  setExpanded={setExpanded}
                  toggle={toggle}
                  setToggle={setToggle}
                />
              </div>
            </Nav.Link>
          );
        } else if (subLinks.length !== 0 && isNormalDropdown) {
          return (
            <Nav.Link
              key={idx}
              className={`ps-0 pe-0 pe-lg-4 ${s.sub_links_wrapper} position-relative overflow-visible`}
              as={"li"}
              onMouseLeave={() => {
                if (isDesktop) setNormalDropdown(false);
              }}
              onMouseEnter={() => {
                if (isDesktop) setNormalDropdown(true);
              }}
            >
              <div
                className={`ps-lg-0 ${s.has_sub} ${normalDropdown ? s.rotate : ""}`}
              >
                <Link
                  className={`${secondaryFont} ${
                    link === asPath ? "active" : ""
                  }`}
                  href={link}
                  onClick={(e) => {
                    if (!isDesktop) {
                      e.preventDefault();
                      setNormalDropdown(!normalDropdown);
                    }
                  }}
                  style={{
                    borderBottom:
                      link === asPath && isDesktop
                        ? "2px solid #1570EF"
                        : "2px solid transparent",
                    // transition: 'border-color 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid #1570EF";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid transparent";
                    }
                  }}
                >
                  {title}
                </Link>
                <IoChevronForward
                  size="22px"
                  onClick={() => {
                    setNormalDropdown(!normalDropdown);
                  }}
                />
              </div>
              <div
                className={`${s.sub_links} ${s.mobile} ${
                  normalDropdown ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              >
                {subLinks.map(({ title, link }, index) => {
                  return (
                    <div className="border-0 pt-3 pb-3" key={index}>
                      <Link
                        href={link}
                        onClick={() => {
                          setExpanded(false);
                        }}
                      >
                        {title}
                      </Link>
                    </div>
                  );
                })}
              </div>
              <div
                className={`${s.sub_links} ${s.desktop} ${
                  toggle ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              ></div>
              <div
                className={`${s.sub_links} ${s.sub_links_normal} ${s.desktop} ${
                  normalDropdown ? s.show_sub_links_normal : ""
                } pt-0 pb-0 ps-3`}
              >
                <DesktopNormaLoansSubMenu
                  subLinks={subLinks}
                  setExpanded={setExpanded}
                  toggle={normalDropdown}
                  setToggle={setNormalDropdown}
                />
              </div>
            </Nav.Link>
          );
        } else {
          return (
            <Nav.Link as={"li"} key={idx} className="mb-0 mb-lg-0 ms-lg-3">
              {/* <Link className={`${secondaryFont} ${s.no_sub} ${link === asPath ? 'active' : ''}`} href={link} onClick={() => { setExpanded(false) }}>
              {title} <ChevronForward />
            </Link> */}
              <Link
                className={`${secondaryFont} ${s.no_sub}`}
                href={link}
                onClick={() => {
                  setExpanded(false);
                }}
                style={{
                  borderBottom:
                    link === asPath && isDesktop
                      ? "2px solid #1570EF"
                      : "2px solid transparent",
                  // transition: 'border-color 0.3s',
                }}
                onMouseEnter={(e) => {
                  if (link != asPath && isDesktop) {
                    e.target.style.borderBottom = "2px solid #1570EF";
                  }
                }}
                onMouseLeave={(e) => {
                  if (link != asPath && isDesktop) {
                    e.target.style.borderBottom = "2px solid transparent";
                  }
                }}
              >
                {title}
                <IoChevronForward className="mob-icon" size="22px" />
              </Link>
            </Nav.Link>
          );
        }
      })}
      <li className="d-flex flex-row align-items-end">
        <Link
          className={`mb-0 mb-lg-0 ms-lg-5 btn btn-mob-full-w btn-primary mb-lg-0 d-md-inline ${s.btn_mod}`}
          href={"/get-a-loan"}
        >
          {"Get A Loan" + "  "}
          <IoArrowForward size="18px" />
        </Link>
      </li>
    </Nav>
  );
};

const DesktopSubMenu = ({ subLinks, setToggle }) => {
  const router = useRouter();

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: true,
  });

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className={`${s.sub_links_desktop} desktop-nav-dropdown`}>
      <section className="embla__nav">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {subLinks.map(({ image, link, title }, index) => (
              <div className="embla__slide" key={index}>
                <div
                  className={s.single_slide_link}
                  onClick={() => setToggle(false)}
                >
                  <Link href={link}>
                    <img src={image} loading="lazy" alt="image" height="100%" />
                    <p>{title}</p>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="embla__controls">
          <div className="embla__buttons">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      </section>
      <Link
        href="/what-we-buy"
        className={`btn btn-outline-dark ${s.see_all}`}
        onClick={(e) => {
          e.preventDefault();
          setToggle(false);
          router.push("/what-we-buy");
        }}
      >
        Things We Buy
      </Link>
    </div>
  );
};

const DesktopNormaLoansSubMenu = ({ subLinks, setToggle }) => {
  return (
    <div
      className={`${s.sub_links_desktop} ${s.sub_links_desktop_normal} desktop-nav-dropdown`}
    >
      {subLinks.map(({ image, link, title }, idx) => {
        return (
          <Link href={link} key={idx}>
            <p>{title}</p>
          </Link>
        );
      })}
    </div>
  );
};

export default Layout;
